import React, {Suspense, useEffect} from 'react'

// ** Router Import
import Router from './router/Router'
import MainApiService from './services/api/MainApiService'
import {logoutIfRefreshTokenNotValid} from './services/AuthService'
import Spinner from "./@core/components/spinner/Fallback-spinner"
import {useSelector} from "react-redux"

const App = () => {

    const mainApiService = new MainApiService()
    const store = useSelector(state => state.loaders)

    useEffect(() => {
        logoutIfRefreshTokenNotValid()
        const interval = setInterval(() => {
            if (localStorage.getItem('userData')) {
                mainApiService.checkAuth()
            }
        }, 60000)
        return () => clearInterval(interval)
    }, [])

    if (store.spinner) {
        return <Spinner/>
    }

    return (
        <Suspense fallback={null}>
            <Router/>
        </Suspense>
    )
}

export default App
